import { render, staticRenderFns } from "./jgggxx.vue?vue&type=template&id=071d70ac&scoped=true"
import script from "./jgggxx.vue?vue&type=script&lang=js"
export * from "./jgggxx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d70ac",
  null
  
)

export default component.exports